import { render, staticRenderFns } from "./ReceiptImportFiles.vue?vue&type=template&id=0824764e&"
import script from "./ReceiptImportFiles.vue?vue&type=script&lang=ts&"
export * from "./ReceiptImportFiles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports